// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function EyeSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6.74 4.327a1 1 0 1 0-1.48 1.346l2.405 2.646c-4.54 2.786-6.493 7.081-6.579 7.276a1 1 0 0 0 0 .812c.044.1 1.103 2.447 3.456 4.8C7.68 24.343 11.64 26 16 26c2.24.013 4.459-.449 6.509-1.354l2.75 3.026a1 1 0 1 0 1.48-1.345l-19.999-22Zm5.916 9.48 5.209 5.732a4 4 0 0 1-5.209-5.732ZM16 24c-3.848 0-7.209-1.399-9.991-4.156A16.646 16.646 0 0 1 3.125 16c.586-1.099 2.457-4.174 5.919-6.172l2.25 2.468a6 6 0 0 0 7.957 8.75l1.841 2.025A14 14 0 0 1 16 24Zm.75-11.929a1 1 0 1 1 .375-1.965 6.02 6.02 0 0 1 4.846 5.33 1 1 0 0 1-.902 1.089.814.814 0 0 1-.094 0 1 1 0 0 1-1-.907 4.011 4.011 0 0 0-3.225-3.547Zm14.16 4.336c-.052.118-1.319 2.922-4.17 5.476a1 1 0 1 1-1.334-1.49A16.593 16.593 0 0 0 28.881 16a16.638 16.638 0 0 0-2.89-3.846C23.21 9.399 19.848 8 16 8c-.81-.001-1.62.065-2.42.196a1 1 0 1 1-.33-1.972A16.75 16.75 0 0 1 16 6c4.36 0 8.321 1.657 11.457 4.794 2.354 2.354 3.413 4.702 3.457 4.801a1 1 0 0 1 0 .812h-.004Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
